import React from 'react';
import SearchComponent from './SearchInputComponent';
import createReactComponent from '../ReactComponentMaker';
import { blockCategories } from '../categories';

export default (editor) => {
    createReactComponent(editor, {
        type: 'search-input-component',
        name: 'Sucheingabe',
        label: 'Sucheingabe',
        category: blockCategories.advance,
        traits: [
            {
                type: 'checkbox',
                name: 'showButton',
                label: 'Button anzeigen',
            },
            {
                type: 'text',
                name: 'placeholder',
                label: 'Platzhalter',
                value: 'Suche...',
            },
        ],
        renderComponent: (attributes) => (
            <SearchComponent traits={attributes} />
        ),
        media:
            `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor"
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search">
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
            `,
    });
};
